import { Button, Flex, Modal } from '@wyz/ui';
import * as React from 'react';
import { Trans, useI18n } from '~/common/context';
import { useMyCustomersAutocomplete } from '~/common/hooks';
import { ICustomerOption } from '~/common/types';
import { CustomerSelectorHelpers } from '~/connect/helpers';
import {
  BaseCustomerSelector,
  useCustomerChangeHandler,
} from '~/purchase/components';
import { usePurchaseContext } from '~/purchase/context';
type CustomerSelectorModalProps = {
  onConfirm: () => void;
};

function CustomerSelectorModal(props: CustomerSelectorModalProps) {
  const { t } = useI18n();
  const { onConfirm } = props;
  const { state } = usePurchaseContext();

  const fetchCustomers = useMyCustomersAutocomplete();
  const [selectedCustomer, setSelectedCustomer] =
    React.useState<ICustomerOption | null>(
      state.primaryCustomer
        ? CustomerSelectorHelpers.customerToOption({
            ...state.primaryCustomer,
            deliveryInformation: {
              city: state.primaryCustomer.deliveryInformation?.city ?? '',
              zipCode: state.primaryCustomer.deliveryInformation?.zipCode ?? '',
              country: {
                currencyId:
                  state.primaryCustomer.deliveryInformation?.country
                    ?.currencyId ?? 0,
              },
            },
          })
        : null,
    );
  const globalOnChange = useCustomerChangeHandler();

  const handleOnConfirm = () => {
    globalOnChange(selectedCustomer);
    onConfirm();
  };

  return (
    <Modal.Container
      open={true}
      onClose={handleOnConfirm}
      backdrop='static'
      centered
    >
      <Modal.Header closeButton={false}>
        <Modal.Title>
          <Trans i18nKey='app.home.customer_modal.title' />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Flex justifyContent='center'>
          <BaseCustomerSelector
            value={selectedCustomer ? selectedCustomer : undefined}
            fetcher={(query, options) =>
              fetchCustomers(query, { signal: options.signal })
            }
            defaultOptionsFetcher={(options) =>
              fetchCustomers('', { signal: options.signal })
            }
            onChange={setSelectedCustomer}
            name='modal-customer'
          />
        </Flex>
      </Modal.Body>
      <Modal.Footer>
        <Flex className='w-100 space-x-4'>
          <Button
            id='submit-modal-customer-selection'
            variant={'primary'}
            type='submit'
            onClick={handleOnConfirm}
            fullWidth
          >
            {t('app.common.buttons.validate')}
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal.Container>
  );
}

export default CustomerSelectorModal;
